var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "600px" },
          model: {
            value: _vm.startDialog,
            callback: function($$v) {
              _vm.startDialog = $$v
            },
            expression: "startDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(_vm._s(_vm.dialogContents.title) + "\n      ")
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _vm._l(_vm.dialogContents.sections, function(item) {
                    return [
                      _c("h2", { key: item.id }, [_vm._v(_vm._s(item.title))]),
                      _vm._v(" "),
                      _vm._l(item.contents, function(para, pindex) {
                        return [
                          _c("p", {
                            key: item.id + "-pi-" + pindex,
                            domProps: { innerHTML: _vm._s(para) }
                          })
                        ]
                      }),
                      _vm._v(" "),
                      item.list
                        ? [
                            _c(
                              "ul",
                              {
                                key: "ul-" + item.id,
                                staticClass: "space-list"
                              },
                              _vm._l(item.list, function(li, lindex) {
                                return _c("li", {
                                  key: "li-" + lindex,
                                  domProps: { innerHTML: _vm._s(li) }
                                })
                              }),
                              0
                            )
                          ]
                        : _vm._e()
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        flat: "flat",
                        href: "static/handbook.pdf",
                        target: "_blank"
                      }
                    },
                    [_vm._v("Download Handbook")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", flat: "flat" },
                      on: {
                        click: function($event) {
                          _vm.startDialog = false
                        }
                      }
                    },
                    [_vm._v("Close")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10f5654a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10f5654a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StartDialog.vue
// module id = null
// module chunks = 